var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCertificate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.6738 45.8477L69.8123 55.7995L80.7988 57.3958L72.7363 64.6602L74.8084 75.4102L64.6738 69.3633L54.5393 75.4102L56.6113 64.6602L48.5488 57.3958L59.8363 55.7995L64.6738 45.8477ZM16.2988 43.1602H32.4238V48.5352H16.2988V43.1602ZM16.2988 32.4102H43.1738V37.7852H16.2988V32.4102ZM16.2988 21.6602H43.1738V27.0352H16.2988V21.6602Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1738 70.0352H10.9238V16.2852H75.4238V43.1602H80.7988V16.2852C80.7988 14.8596 80.2325 13.4925 79.2245 12.4845C78.2165 11.4764 76.8494 10.9102 75.4238 10.9102H10.9238C9.49829 10.9102 8.13114 11.4764 7.12313 12.4845C6.11512 13.4925 5.54883 14.8596 5.54883 16.2852V70.0352C5.54883 71.4607 6.11512 72.8278 7.12313 73.8359C8.13114 74.8439 9.49829 75.4102 10.9238 75.4102H43.1738V70.0352Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.0089d2c0f7a62827d04f164b8ec5bd0e.svg";
export { ForwardRef as ReactComponent };